var _vars = require('../../modules/vars')._vars;

var MODAL_CLASS = 'v2-answer-modal';
var BODY_OPEN_CLASS = 'v2-answer-modal-open';

// Icons injected into the V2 (for-you) document from inside the modal.
var SEARCH_ICON = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjI0MjE5IDEuMjVDNC4zODA1MSAxLjI1IDEuMjUgNC4zODA1MSAxLjI1IDguMjQyMTlDMS4yNSAxMi4xMDM5IDQuMzgwNTEgMTUuMjM0NCA4LjI0MjE5IDE1LjIzNDRDMTAuMTIxMiAxNS4yMzQ0IDExLjgyNiAxNC40OTQgMTMuMDgyOSAxMy4yODc4QzE0LjQwOTcgMTIuMDE0NiAxNS4yMzQ0IDEwLjIyNTIgMTUuMjM0NCA4LjI0MjE5QzE1LjIzNDQgNC4zODA1MSAxMi4xMDM5IDEuMjUgOC4yNDIxOSAxLjI1Wk0wIDguMjQyMTlDMCAzLjY5MDE1IDMuNjkwMTUgMCA4LjI0MjE5IDBDMTIuNzk0MiAwIDE2LjQ4NDQgMy42OTAxNSAxNi40ODQ0IDguMjQyMTlDMTYuNDg0NCAxMC4zNDU2IDE1LjY5NTggMTIuMjY1NyAxNC4zOTkzIDEzLjcyMTZMMTkuODA4MyAxOC45MjQ2QzIwLjA1NzEgMTkuMTYzOSAyMC4wNjQ3IDE5LjU1OTUgMTkuODI1NCAxOS44MDgzQzE5LjU4NjEgMjAuMDU3MSAxOS4xOTA1IDIwLjA2NDcgMTguOTQxNyAxOS44MjU0TDEzLjQ5OTQgMTQuNTkwM0MxMi4wNzI5IDE1Ljc3MjkgMTAuMjQwMSAxNi40ODQ0IDguMjQyMTkgMTYuNDg0NEMzLjY5MDE1IDE2LjQ4NDQgMCAxMi43OTQyIDAgOC4yNDIxOVoiIGZpbGw9IiMwNjRBQTciLz4KPC9zdmc+Cg==';
var EXTERNAL_ICON = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDEuMTI1QzAgMC41MDM2ODEgMC41MDM2NzkgMCAxLjEyNSAwSDYuMTg3NUM2LjQ5ODE2IDAgNi43NSAwLjI1MTg0IDYuNzUgMC41NjI1QzYuNzUgMC44NzMxNiA2LjQ5ODE2IDEuMTI1IDYuMTg3NSAxLjEyNUwxLjEyNSAxLjEyNVYxNi44NzVIMTYuODc1VjExLjgxMjVDMTYuODc1IDExLjUwMTggMTcuMTI2OCAxMS4yNSAxNy40Mzc1IDExLjI1QzE3Ljc0ODIgMTEuMjUgMTggMTEuNTAxOCAxOCAxMS44MTI1VjE2Ljg3NUMxOCAxNy40OTYzIDE3LjQ5NjMgMTggMTYuODc1IDE4SDEuMTI1QzAuNTAzNjggMTggMCAxNy40OTYzIDAgMTYuODc1VjEuMTI1Wk05LjU2MjUyIDAuNTYyNUM5LjU2MjUyIDAuMjUxODQgOS44MTQzNiAwIDEwLjEyNSAwSDE3LjQzNzVDMTcuNzQ4MiAwIDE4IDAuMjUxODQgMTggMC41NjI1VjcuODc1MDJDMTggOC4xODU2OCAxNy43NDgyIDguNDM3NTIgMTcuNDM3NSA4LjQzNzUyQzE3LjEyNjggOC40Mzc1MiAxNi44NzUgOC4xODU2OCAxNi44NzUgNy44NzUwMlYxLjkyMDVMNi41ODUyNSAxMi4yMTAyQzYuMzY1NTggMTIuNDI5OSA2LjAwOTQyIDEyLjQyOTkgNS43ODk3NSAxMi4yMTAyQzUuNTcwMDggMTEuOTkwNiA1LjU3MDA4IDExLjYzNDQgNS43ODk3NSAxMS40MTQ4TDE2LjA3OTUgMS4xMjVIMTAuMTI1QzkuODE0MzYgMS4xMjUgOS41NjI1MiAwLjg3MzE2IDkuNTYyNTIgMC41NjI1WiIgZmlsbD0iIzA2NEFBNyIvPgo8L3N2Zz4K';

// CSS injected into the V2 document. ::before/::after do not render on <textarea>, so the search
// icon is a background-image on the input with padding-left to make room for it.
var FRAME_CSS = [
    '.page-header { display: none !important; }',
    '.ai-layer-header { display: none !important; }',
    '.ai-layer-search-row .ai-layer-side-button { display: none !important; }',
    '.ai-layer-body { background: #fff !important; }',
    '.ai-layer-footer { background: #fff !important; }',
    '.layer-question-ad--with-disclaimer { display: none !important; }',
    '.ai-layer-content { padding-top: 16px !important; }',
    // Icon only on the input itself (::before does not render on <textarea>); transparent bg so
    // the wrapper's gradient shows through.
    '.medscape-ai-input-box {',
    '    background: url("' + SEARCH_ICON + '") no-repeat 20px 16px !important;',
    '    padding-left: 48px !important;',
    '}',
    // Gradient-border on the wrapper component (border transparent so the border-box layer shows).
    '.medscape-ai-input-component.search-bar {',
    '    border: 1px solid transparent !important;',
    '    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.07), 0 7px 28px 0 rgba(0, 0, 0, 0.10) !important;',
    '    background: linear-gradient(var(--color-background-article-section, #ecf1f9), var(--color-background-article-section, #ecf1f9)) padding-box, linear-gradient(190deg, var(--color-icon-illustrative-ai-left), var(--color-icon-illustrative-ai-right)) border-box !important;',
    '}',
    '.v2-continue-link {',
    '    display: flex;',
    '    align-items: center;',
    '    gap: 8px;',
    '    margin: 8px auto;',
    '    color: var(--color-text-brand-default, rgb(6, 74, 167));',
    '    font-weight: 600;',
    '    text-decoration: none;',
    '}',
    '.v2-continue-link__icon {',
    '    width: 18px;',
    '    height: 18px;',
    '    display: inline-block;',
    '    flex-shrink: 0;',
    '    background-image: url("' + EXTERNAL_ICON + '");',
    '    background-repeat: no-repeat;',
    '    background-size: contain;',
    '}'
].join('\n');

var activeModal = null;

// Apply the DOM changes the CSS can't: set the input placeholder and add the "Continue
// conversation in new tab" link after the search row. Idempotent so the MutationObserver can
// re-run it as the V2 app renders.
function applyFrameDom(doc, homeUrl) {
    var input = doc.querySelector('.medscape-ai-input-box');
    if (input && input.getAttribute('placeholder') !== 'Ask anything') {
        input.setAttribute('placeholder', 'Ask anything');
    }

    var row = doc.querySelector('.ai-layer-search-row');
    if (row && row.parentNode && !doc.querySelector('.v2-continue-link')) {
        var link = doc.createElement('a');
        link.className = 'v2-continue-link label-1';
        link.href = homeUrl;
        link.target = '_blank';
        link.rel = 'noopener';

        var label = doc.createElement('span');
        label.textContent = 'Continue conversation in new tab';

        var icon = doc.createElement('span');
        icon.className = 'v2-continue-link__icon';

        link.appendChild(label);
        link.appendChild(icon);
        // Sibling immediately after .ai-layer-search-row, not a child of it.
        row.insertAdjacentElement('afterend', link);
    }
}

function isV2AIEnabled() {
    if (typeof window === 'undefined') { return false; }
    if (window.useV2AI === true) { return true; }
    try {
        var param = new URLSearchParams(window.location.search).get('isv2ai');
        if (param !== null) {
            var value = param.toLowerCase();
            if (value !== 'false' && value !== '0') {
                window.useV2AI = true;
                return true;
            }
        }
    } catch (e) { /* URLSearchParams unavailable */ }
    return false;
}

function isMobileViewport() {
    // matchMedia is live, so it stays correct after a resize. window.breakpoint is set at page
    // load and goes stale on resize, so it's only a fallback when matchMedia is unavailable.
    if (window.matchMedia) {
        return window.matchMedia('(max-width: 767px)').matches;
    }
    if (typeof window.breakpoint !== 'undefined') {
        return Number(window.breakpoint) === 1;
    }
    return false;
}

function buildV2Url(query) {
    return 'https://www.' + _vars.friendlyEnv + 'medscape.com/for-you?earlyaccess=&icd=&query=' + encodeURIComponent(query);
}

function openInNewTab(url) {
    window.open(url, '_blank', 'noopener');
}

function closeModal() {
    if (!activeModal) { return; }
    var state = activeModal;
    activeModal = null;

    document.removeEventListener('keydown', state.onKeydown);
    if (state.observer) { state.observer.disconnect(); }
    clearRevealTimers(state);
    if (state.root.parentNode) { state.root.parentNode.removeChild(state.root); }
    document.body.classList.remove(BODY_OPEN_CLASS);

    if (state.opener && typeof state.opener.focus === 'function') {
        state.opener.focus();
    }
}

// Shimmer skeleton shown over the iframe until the framed V2 page is styled and ready. Rough
// shape of the answer layout (title, chips, takeaways, bullets, input).
function buildShimmer() {
    var shimmer = document.createElement('div');
    shimmer.className = MODAL_CLASS + '__shimmer';

    function block(h, w, radius) {
        var el = document.createElement('div');
        el.className = 'v2-sh';
        el.style.height = h;
        if (w) { el.style.width = w; }
        if (radius) { el.style.borderRadius = radius; }
        return el;
    }
    function row(children) {
        var r = document.createElement('div');
        r.className = 'v2-sh-row';
        children.forEach(function(c) { r.appendChild(c); });
        return r;
    }

    shimmer.appendChild(block('28px', '92%'));           // title line 1
    shimmer.appendChild(block('28px', '60%'));           // title line 2
    shimmer.appendChild(row([block('36px', '150px', '999px'), block('36px', '110px', '999px')])); // chips
    shimmer.appendChild(block('20px', '45%'));           // "Quick takeaways"
    for (var i = 0; i < 2; i++) {
        shimmer.appendChild(block('16px', '100%'));
        shimmer.appendChild(block('16px', '96%'));
        shimmer.appendChild(block('16px', '70%'));
        shimmer.appendChild(block('14px', '130px', '6px')); // source tag
    }

    var spacer = document.createElement('div');
    spacer.className = 'v2-sh-spacer';
    shimmer.appendChild(spacer);

    shimmer.appendChild(block('56px', '100%', '999px'));  // follow-up input
    return shimmer;
}

// The framed app is ready once its main content and search bar have rendered; our injected CSS
// (already in the frame's <head>) applies to them immediately, so revealing now shows no shift.
function isFrameContentReady(doc) {
    return !!(doc.querySelector('.ai-layer-content')
        && doc.querySelector('.medscape-ai-input-component.search-bar'));
}

function clearRevealTimers(state) {
    if (state.revealTimer) { clearTimeout(state.revealTimer); state.revealTimer = null; }
    if (state.maxRevealTimer) { clearTimeout(state.maxRevealTimer); state.maxRevealTimer = null; }
    if (state.pollTimer) { clearInterval(state.pollTimer); state.pollTimer = null; }
}

function revealFrame(state) {
    if (!state || state.revealed) { return; }
    state.revealed = true;
    clearRevealTimers(state);
    if (state.frame) { state.frame.classList.add('is-ready'); }
    if (state.shimmer && state.shimmer.parentNode) {
        state.shimmer.parentNode.removeChild(state.shimmer);
    }
}

// Reveal shortly after content is detected, so the final paint settles first.
function scheduleReveal(state) {
    if (!state || state.revealed || state.revealTimer) { return; }
    state.revealTimer = setTimeout(function() { revealFrame(state); }, 120);
}

// Full-viewport modal that loads the V2 answer page in an iframe. The V2 app runs in its own
// document, so it can't affect the article page and gets its own config/API access.
function openIframeModal(url, opener) {
    if (activeModal) { return; }

    var root = document.createElement('div');
    root.className = MODAL_CLASS;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'AI answer');

    var bar = document.createElement('div');
    bar.className = MODAL_CLASS + '__bar';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = MODAL_CLASS + '__close';
    closeBtn.setAttribute('aria-label', 'Close');
    // The X is drawn with CSS (::before/::after), so no text content here.
    closeBtn.addEventListener('click', closeModal);
    bar.appendChild(closeBtn);

    var body = document.createElement('div');
    body.className = MODAL_CLASS + '__body';

    var shimmer = buildShimmer();

    var frame = document.createElement('iframe');
    frame.className = MODAL_CLASS + '__frame';
    frame.title = 'AI answer';

    body.appendChild(frame);
    body.appendChild(shimmer);
    root.appendChild(bar);
    root.appendChild(body);
    document.body.appendChild(root);
    document.body.classList.add(BODY_OPEN_CLASS);

    var state = {
        root: root,
        frame: frame,
        shimmer: shimmer,
        opener: opener,
        observer: null,
        styledDoc: null,
        revealed: false,
        pollTimer: null,
        revealTimer: null,
        maxRevealTimer: null,
        onKeydown: function(e) {
            if (e.key === 'Escape') { closeModal(); }
        }
    };
    document.addEventListener('keydown', state.onKeydown);
    closeBtn.focus();
    activeModal = state;

    var homeUrl = 'https://www.' + _vars.friendlyEnv + 'medscape.com/for-you';

    // Inject our CSS the instant the framed document's <head> exists (before the app paints), so
    // the user never sees the V2 default styling flash and shift — important on slow connections,
    // where waiting for the iframe 'load' event is too late. Polling + reapplying on doc change is
    // what makes this fire ahead of the app.
    function initFrame() {
        if (state.revealed) { return; }
        var doc;
        try {
            doc = frame.contentDocument || frame.contentWindow.document;
        } catch (e) {
            // Cross-origin (e.g. redirected to login) — can't style it, so just show it.
            revealFrame(state);
            return;
        }
        if (!doc || !doc.head) { return; }

        // location.replace swaps the document object (about:blank -> for-you); when that happens
        // re-inject into the new doc and rebind the observer to it.
        if (state.styledDoc !== doc) {
            state.styledDoc = doc;
            var style = doc.createElement('style');
            style.textContent = FRAME_CSS;
            doc.head.appendChild(style);
            if (state.observer) { state.observer.disconnect(); state.observer = null; }
        }

        applyFrameDom(doc, homeUrl);

        if (!state.observer && doc.body && typeof MutationObserver === 'function') {
            state.observer = new MutationObserver(function() {
                applyFrameDom(doc, homeUrl);
                if (isFrameContentReady(doc)) { scheduleReveal(state); }
            });
            state.observer.observe(doc.body, { childList: true, subtree: true });
        }

        if (isFrameContentReady(doc)) { scheduleReveal(state); }
    }

    // Navigate with location.replace() instead of setting src: the iframe is same-origin, so
    // setting src adds an entry to the browser's shared history. That is what made closing the
    // layer (or the mobile Back button) land on the for-you page. replace() adds no entry, and
    // the query travels in the URL either way.
    try {
        frame.contentWindow.location.replace(url);
    } catch (e) {
        frame.src = url;
    }

    frame.addEventListener('load', initFrame);
    state.pollTimer = setInterval(initFrame, 30);
    initFrame();

    // Safety net: never leave the user stuck on the shimmer if readiness is never detected.
    state.maxRevealTimer = setTimeout(function() { revealFrame(state); }, 8000);
}

function openV2Answer(query, opener) {
    var url = buildV2Url(query);
    if (isMobileViewport()) {
        openIframeModal(url, opener);
    } else {
        openInNewTab(url);
    }
}

module.exports = {
    isV2AIEnabled: isV2AIEnabled,
    buildV2Url:    buildV2Url,
    openV2Answer:  openV2Answer,
    closeModal:    closeModal
};
